import { sanitizeName } from '@/shared/utils/sanitizeName';

export const sanitizeProjectName = (value, opts) => sanitizeName(value, opts);

export const sanitizeTaskName = (value, opts) => sanitizeName(value, opts);
